import React from 'react';
import { Badge } from 'antd';
import './status-badge.scss';

const defaultStatusList = [
    { key: 'pending', label: 'Pending', color: 'grey' },
    { key: 'partiallycompleted', label: 'Partially completed', color: 'orange' },
    { key: 'completed', label: 'Completed', color: 'blue' },
    { key: 'authorized', label: 'Authorized', color: 'green' },
];

const StatusBadge = ({ statusKey, showLegend = false, statusList = defaultStatusList }) => {
    if (showLegend) {
        return (
            <div className="test-status-legend">
                {statusList.map((s) => (
                    <span key={s.key} style={{ marginRight: 8, color: s.color }}>
                        <Badge color={s.color} /> {s.label}
                    </span>
                ))}
            </div>
        );
    }

    // Directly match backend statusKey to statusList
    const current = statusList.find((s) => s.key === statusKey);
    const color = current?.color || 'grey';

    // Only show colored dot
    return <Badge className="test-status" color={color} />;
};

export default StatusBadge;;
